// eslint-disable-next-line no-use-before-define
import React from 'react';
import { VueInReact } from 'vuera-ts';
import Avatar from '../../../../components/avatar/Avatar.vue';
import { getOtherUserInformation } from '../../js/getOtherUserInformation';
import { sendSegmentEvent } from '../../../../lib/segment';

import {
  getLastMessageDate,
  getChannelPreviewImage,
  getChannelPreviewName,
  getLastMessageContent,
  getUnreadMsgLabel,
  getActiveChannelClass,
  getProfileLink,
} from '../../js/channelPreviewUtils';

const AvatarReact = VueInReact(Avatar);

const CustomChannelPreview = ({ props, userId, currentChannelUrl, accountType }) => {
  const { channel } = props;
  const { url, members, lastMessage, unreadMessageCount } = channel;

  const otherUserInfo = getOtherUserInformation(members, userId);
  const lastMessageDate = getLastMessageDate(otherUserInfo, lastMessage);
  const channelPreviewImage = getChannelPreviewImage(otherUserInfo);
  const channelPreviewName = getChannelPreviewName(otherUserInfo);
  const lastMessageContent = getLastMessageContent(otherUserInfo, lastMessage);
  const unreadMsgLabel = getUnreadMsgLabel(unreadMessageCount);
  const activeChannelClass = getActiveChannelClass(url, currentChannelUrl);
  const profileLink = getProfileLink(accountType, otherUserInfo);

  const handleProfileClick = () => {
    if (accountType === 'parent') {
      sendSegmentEvent('Viewed Profile in Message', {
        viewed_profile_id: otherUserInfo.correspondingUserId,
      });
    }
  };

  return (
    channel && (
      <div className="channel-preview border-b-1 border-solid border-grey-divider-subdued" id={channel.url}>
        <button className={`channel-preview--btn flex gap-16 w-full px-16 py-8 ${activeChannelClass}`}>
          {profileLink ? (
            <a
              href={profileLink}
              target="_blank"
              onClick={handleProfileClick}
              tabIndex="-1"
              aria-label={`View ${otherUserInfo.name}'s profile`}
            >
              <AvatarReact name={channelPreviewName} imageUrl={channelPreviewImage} size={'xl'} emptyAlt={true} />
            </a>
          ) : (
            <AvatarReact name={channelPreviewName} imageUrl={channelPreviewImage} size={'xl'} emptyAlt={true} />
          )}

          <div className="channel-preview--content flex flex-col w-full">
            <div className="channel-preview--upper flex justify-between items-center">
              <p className="channel-preview--name text-strong-body truncate">{channelPreviewName}</p>
              <p className="text-caption text-grey-text-subdued">{lastMessageDate}</p>
            </div>

            <div className="channel-preview--lower flex justify-between items-center gap-32">
              <p
                className="channel-preview--message flex-1 text-caption text-grey-text-subdued text-left text-ellipsis overflow-hidden"
                style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
              >
                {lastMessageContent}
              </p>
              {unreadMessageCount > 0 && (
                <span
                  className="channel-preview--unread-badge flex items-center justify-center text-overline text-white h-20 p-4"
                  aria-label={unreadMsgLabel}
                >
                  {unreadMessageCount}
                </span>
              )}
            </div>
          </div>
        </button>
      </div>
    )
  );
};

export default CustomChannelPreview;
